import LotsConfig  from "./LotsConfig";

export default LotsConfig;